import React, { useEffect, useState } from 'react';
import {
    Col,
    Row,
    Label
} from "reactstrap";
import {
    checkWhiteSpaces,
    number,
    alphaNumeric,
    alphabetsOnly,
    notify,
    nonZero,
    apiErrors,
} from '../../../../../../../../helper';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { cloneDeep } from 'lodash';
import { SearchableSelectHookForm, TextFieldHookForm } from '../../../../../../../layout/HookFormInputs';
import { getRelationService } from '../../../../../../supplierListAll/Actions';
import axiosHelper from '../../../../../../../../axiosHelper';
import { API } from '../../../../../../../../config/constants';
import LoaderCustom from '../../../../../../../common/LoaderCustom';
import HeaderTitle from '../../../../../../../common/HeaderTitle';

let sisterConcernItemInitData = {
    VendorCode: "",
    VendorName: "",
    Mobile: ""
}

let radioValidateMsg = "This field is required.";

const BusinessDetails = (props) => {
    // let supplierDetail = props.supplierDetail;
    const [relationshipList, setRelationshipList] = useState([]);
    const [showTabLoader, setShowTabLoader] = useState(true)
    const [supplierDetail, setSupplierDetail] = useState(null)
    const [specializationList, setSpecializationList] = useState([])
    const [hasSupplierCodeChanged, setHasSupplierCodeChanged] = useState({});
    const [isSupplierCodeValid, setIsSupplierCodeValid] = useState({});

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get("VendorRequirementRegistrationId");
        if (id) {
            GetKYS1DetailByVendorRRId(id)
        }
        getSpecializationList()
    }, []);
    // GetKYS1DetailByVendorRRId?VendorRequirementRegistrationId=113
    const GetKYS1DetailByVendorRRId = (id) => {
        axiosHelper.get(`${API.GetKYS1DetailByVendorRRId}?VendorRequirementRegistrationId=${id}`)
            .then(async (res) => {
                setSupplierDetail(res?.data?.Data)
            })
            .catch((error) => {

            });
    }

    const getSpecializationList = () => {
        axiosHelper.get(`${API.getSpecializationList}`).then((response) => {
            if (response.data.IsSuccessful) {
                let list = response?.data?.Data?.map(el => ({ label: el?.SpecializationName?.trim(), value: el.Id }));
                setSpecializationList(list)
            }
        })
            .catch((error) => {
                if (!error?.response?.data?.IsSuccessful) {
                    notify.error(error?.response?.data?.ErrorMessage)
                }
            });
    }

    const hidePageLoader = () => setTimeout(() => {
        setShowTabLoader(false);
    }, 2000);

    const formController = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        setValue,
        trigger,
        getValues,
        reset,
        resetField,
        formState: { errors },
        control,
    } = formController;

    // 

    const { fields, append, remove } = useFieldArray({
        control,
        name: "OtherSisterConcern"
    });

    const getRelationshipMasterList = () => {
        getRelationService()
            .then((res) => {
                let list = res?.Data?.map(el => ({ label: el.Name, value: el.Id }));
                setRelationshipList(list);
            })
            .catch(() => { });
    };

    const onSubmitBusinessDetails = (values) => {
        let payload = cloneDeep(values);
        if (!payload.TraderForGoods && !payload.ManufacturerForGoods && !payload.OwnForService && !payload.OutSourceForService) {
            notify.error("At least one selection is required in For Services or For Goods");
            return;
        }
        payload.RelationShip = values?.RelationShip?.value;
        payload.SupplierSpecialization = values?.SupplierSpecialization?.value;
        payload.KYS1RegistrationId = supplierDetail?.BusinessDetails?.KYS1RegistrationId;
        if (payload.IsOtherSisterConcern === "false") {
            payload.OtherSisterConcern = null
        };

        setShowTabLoader(true);
        axiosHelper.post(`${API.addAndUpdateKYS1BusinessDetail}`, payload)
            .then((response) => {
                if (response.data.IsSuccessful) {
                    notify.success(response?.data?.Data?.Message)
                    props.toggleKys1FormTabs("3")
                    hidePageLoader()
                }
            })
            .catch((error) => {
                hidePageLoader();
                if (!error?.response?.data?.IsSuccessful) {
                    notify.error(error?.response?.data?.ErrorMessage)
                }

            });
    }

    useEffect(() => {
        getRelationshipMasterList()
    }, [])

    const setBusinessDetailsFormEditData = (businessDetails) => {
        // TraderForGoods
        // ManufacturerForGoods
        // OwnForService
        // OutSourceForService
        let editData = {
            ...businessDetails,
            TotalStaff: businessDetails?.TotalStaff,
            TotalWorkers: businessDetails?.TotalWorkers,
            SupplierSpecialization: !!businessDetails?.SupplierSpecialization ? {
                label: businessDetails?.SupplierSpecializationName,
                value: businessDetails?.SupplierSpecialization
            } : null,
            // IsOtherSisterConcern: businessDetails?.IsOtherSisterConcern?.toString(),
            // IsAnyRelationWithQRG: businessDetails?.IsAnyRelationWithQRG?.toString(),
            // RelationShip: !!businessDetails?.RelationShip ? {
            //     label: businessDetails?.RelationShipName,
            //     value: businessDetails?.RelationShip
            // } : null,
            // OtherSisterConcern: businessDetails?.IsOtherSisterConcern == true &&
            //     businessDetails?.OtherSisterConcern?.length > 0 ?
            //     businessDetails?.OtherSisterConcern : [sisterConcernItemInitData]
        }
        reset(editData);
        setTimeout(() => {
            reset(editData);
            setValue("IsOtherSisterConcern", businessDetails?.IsOtherSisterConcern?.toString())
            setValue("IsAnyRelationWithQRG", businessDetails?.IsAnyRelationWithQRG?.toString())
            setValue("OtherSisterConcern", businessDetails?.IsOtherSisterConcern == true &&
                businessDetails?.OtherSisterConcern?.length > 0 ?
                businessDetails?.OtherSisterConcern : [sisterConcernItemInitData])
            setValue("RelationShip", !!businessDetails?.RelationShip ? {
                label: businessDetails?.RelationShipName,
                value: businessDetails?.RelationShip
            } : null)
        }, 1000);
        hidePageLoader()
        // setTimeout(() => {
        //     setValue("OtherSisterConcern", businessDetails?.OtherSisterConcern)
        // }, 5000)
    }

    useEffect(() => {
        // if (supplierDetail?.BusinessDetails) {
        setBusinessDetailsFormEditData(supplierDetail?.BusinessDetails);
        // }
    }, [supplierDetail])

    let IsOtherSisterConcern = watch('IsOtherSisterConcern');
    let IsAnyRelationWithQRG = watch('IsAnyRelationWithQRG');

    function reorderObject(obj, deleteKey) {
        const keys = Object.keys(obj);
        const newKeys = [];
        const values = [];

        // Collect keys and values in arrays
        for (const key of keys) {
            if (key !== deleteKey) {
                newKeys.push(key);
                values.push(obj[key]);
            }
        }

        // Create new reordered object
        const reorderedObj = {};
        for (let i = 0; i < newKeys.length; i++) {
            const newKey = newKeys[i].replace(/OtherSisterConcern\.\d+\./, `OtherSisterConcern.${i}.`);
            reorderedObj[newKey] = values[i];
        }

        return reorderedObj;
    }

    const removeOtherSisterConcernItem = (rowIndex, isSupplierCodeValid = null) => {
        if (isSupplierCodeValid) {
            let formFieldNameKey = `OtherSisterConcern.${rowIndex}.VendorCode`;
            let updated = reorderObject(isSupplierCodeValid, formFieldNameKey);
            setIsSupplierCodeValid(updated);
        }

        remove(rowIndex)
        let formValues = formController.getValues();
        reset(formValues);
    }

    const validateSupplierCode = async (supplierCode, formFieldNameKey, index) => {
        if (supplierCode) {
            setShowTabLoader(true);
            supplierCode = supplierCode.toUpperCase();
            let url = `${API.checkSupplierCodeIsValid}?vendorCode=${supplierCode}`;
            const request = axiosHelper.get(url);
            request
                .then((response) => {
                    if (response.data.IsSuccessful) {
                        clearErrors(formFieldNameKey)
                        setShowTabLoader(false);
                        // setIsSupplierCodeValid(prevValues => {
                        //     return ({
                        //         ...prevValues,
                        //         [formFieldNameKey]: true
                        //     })
                        // });
                        setValue(`OtherSisterConcern.${index}.VendorName`, response?.data?.Data?.SupplierName)
                        setValue(`OtherSisterConcern.${index}.Mobile`, response?.data?.Data?.SupplierPhoneNo)
                        notify.success(response?.data?.FriendlyMessage);
                        trigger(`OtherSisterConcern.${index}.VendorName`)
                        trigger(`OtherSisterConcern.${index}.Mobile`)
                    }
                })
                .catch((error) => {
                    if (error.response.status === 401) {
                        apiErrors(error)
                      }else{

                          if (error.response && error.response.status === 400) {
                              const responseData = error.response.data;
                              if (!responseData.IsSuccessful) {
                                  notify.error(responseData?.ErrorMessage);
                                  setShowTabLoader(false);
                                  setValue(`OtherSisterConcern.${index}.VendorName`, "")
                                  setValue(`OtherSisterConcern.${index}.Mobile`, "")
                                  //     setIsSupplierCodeValid(prevValues => {
                                  //         return ({
                                  //             ...prevValues,
                                  //             [formFieldNameKey]: false
                                  //         })
                                  //     });
                                  //     setError(formFieldNameKey, {
                                  //         type: 'manual',
                                  //         message: responseData.ErrorMessage,
                                  //     });
                                  //     return false;
                              }
                          }
                      }
                });
        }
    };


    return (
        <>
            {showTabLoader && (<LoaderCustom customClass="simulation-Loader" />)}
            <div className='hl-business-details-wrap businessDetailsWrapper shadow-lgg login-formg'>
                {
                    !supplierDetail?.IsKYS1Editable && (
                        <div className='disableKys1Form'>  </div>
                    )
                }
                <form onSubmit={handleSubmit(onSubmitBusinessDetails)}>
                    <Row className="part-detail-wrapper mt-2 mb-2">
                        <Col md="12 mt-1 mb-3"><HeaderTitle title={"Nature of Business with Havells"} /></Col>
                        <Col md="3">
                            <div className="hl-title-tooltip">
                                <Label className="d-inline-block mr-5 pt-0 mb-1">
                                    For Goods
                                </Label>
                            </div>
                            <div className="mb-2 w-100">
                                <Label className="d-inline-block align-middle w-auto pr-5 mr-5 pr-4 pt-0 custom-checkbox" check>
                                    Trader
                                    <input
                                        type="checkbox"
                                        className="zero-based"
                                        value={true}
                                        {...register("TraderForGoods")}
                                    />
                                    <span className="before-box"></span>
                                </Label>
                                <Label className="d-inline-block align-middle w-auto pt-0 custom-checkbox">
                                    Manufacturer
                                    <input
                                        type="checkbox"
                                        className="vendor-based"
                                        value={true}
                                        {...register("ManufacturerForGoods")}
                                    />
                                    <span className="before-box"></span>
                                </Label>
                            </div>
                        </Col>
                        <Col md="3">
                            <div className="hl-title-tooltip">
                                <Label className="d-inline-block pl-1 mr-5 pt-0 mb-1">
                                    For Services
                                </Label>
                            </div>
                            <div className="mb-2 w-100">
                                <Label className="d-inline-block align-middle w-auto pr-5 mr-5 pr-4 pt-0 custom-checkbox" check>
                                    Own
                                    <input
                                        type="checkbox"
                                        className="zero-based"
                                        value={true}
                                        {...register("OwnForService")}
                                    />
                                    <span className="before-box"></span>
                                </Label>
                                <Label className="d-inline-block align-middle w-auto pt-0 custom-checkbox">
                                    Outsource
                                    <input
                                        type="checkbox"
                                        className="vendor-based"
                                        value={true}
                                        {...register("OutSourceForService")}
                                    />
                                    <span className="before-box"></span>
                                </Label>
                            </div>
                        </Col>
                        {/* {errors?.OutSourceForService && errors?.OwnForService && errors?.TraderForGoods && errors?.ManufacturerForGoods && (
                            <div className="text-help">
                                Please select at least one field.
                            </div>
                        )} */}
                    </Row>

                    <Row className="part-detail-wrapper sisterConcernWrapper mb-1">
                        <Col md="12"><hr className="hr-seprator mb-3" /></Col>
                        <Col md="12">
                            <Label>
                                Do you have another Sister Concern which is Supplying to Havells Group?
                                <span className="asterisk-required">*</span>
                            </Label>
                            <Label className={"d-inline-block align-middle w-auto pl0 pr-5 mr-5 mb-1 pt-0 radio-box pl-1"} >
                                <input
                                    type="radio"
                                    className="zero-based"
                                    // rules={{ required: true }}
                                    // {...register("IsOtherSisterConcern")}
                                    {...register("IsOtherSisterConcern", { required: radioValidateMsg })}
                                    value="true"
                                // defaultChecked
                                />
                                <span>Yes</span>
                            </Label>
                            <Label className={"d-inline-block align-middle w-auto pl0 mb-1 pt-0 radio-box"} >
                                <input
                                    type="radio"
                                    // rules={{ required: true }}
                                    // {...register("IsOtherSisterConcern")}
                                    {...register("IsOtherSisterConcern", { required: radioValidateMsg })}
                                    className="vendor-based2"
                                    value="false"
                                />
                                <span>No</span>
                            </Label>
                            {errors?.IsOtherSisterConcern && (
                                <div className="text-help">
                                    {errors?.IsOtherSisterConcern?.message}
                                </div>
                            )}
                        </Col>
                        <Col md="12">
                            {
                                IsOtherSisterConcern === 'true' && (
                                    < >
                                        {fields.map((item, index) => {
                                            let formFieldNameKey = `OtherSisterConcern.${index}.VendorCode`;
                                            return (
                                                <span className='sisterConcernItems' key={index}>
                                                    <Row>
                                                        <Col md="3">
                                                            <TextFieldHookForm
                                                                // {...register(`OtherSisterConcern.${index}.VendorCode`)}
                                                                register={register}
                                                                name={`OtherSisterConcern.${index}.VendorCode`}
                                                                label={`Supplier Code`}
                                                                Controller={Controller}
                                                                control={control}
                                                                placeholder={"Enter"}
                                                                rules={{
                                                                    required: true,
                                                                    validate: { checkWhiteSpaces, alphaNumeric },
                                                                    maxLength: 20,
                                                                }}
                                                                customClassName={"withBorder"}
                                                                errors={errors?.OtherSisterConcern?.[index]?.VendorCode}
                                                                disabled={false}
                                                                mandatory={true}
                                                                handleChange={(e) => {
                                                                    setIsSupplierCodeValid(prevValues => {
                                                                        return ({
                                                                            ...prevValues,
                                                                            [formFieldNameKey]: false
                                                                        })
                                                                    });
                                                                    setHasSupplierCodeChanged(prevValues => {
                                                                        return ({
                                                                            ...prevValues,
                                                                            [formFieldNameKey]: true
                                                                        })
                                                                    });
                                                                    const uppercaseValue = e.target.value.toUpperCase(); // Convert input value to uppercase
                                                                    e.target.value = uppercaseValue;
                                                                }}
                                                                onFieldBlur={(e) => {
                                                                    if (hasSupplierCodeChanged[formFieldNameKey]) {
                                                                        validateSupplierCode(e.target.value, formFieldNameKey, index);
                                                                        setHasSupplierCodeChanged(prevValues => {
                                                                            return ({
                                                                                ...prevValues,
                                                                                [formFieldNameKey]: false
                                                                            })
                                                                        });
                                                                    }
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col md="3">
                                                            <TextFieldHookForm
                                                                // {...register(`OtherSisterConcern.${index}.VendorName`)}
                                                                register={register}
                                                                name={`OtherSisterConcern.${index}.VendorName`}
                                                                label={`Supplier Name`}
                                                                Controller={Controller}
                                                                control={control}
                                                                placeholder={"Enter"}
                                                                handleChange={() => { }}
                                                                rules={{
                                                                    required: true,
                                                                    validate: { checkWhiteSpaces },
                                                                    maxLength: 200,
                                                                }}
                                                                customClassName={"withBorder"}
                                                                errors={errors?.OtherSisterConcern?.[index]?.VendorName}
                                                                disabled={true}
                                                                mandatory={true}
                                                            />
                                                        </Col>
                                                        <Col md="3" className='d-flex align-items-center'>
                                                            <TextFieldHookForm
                                                                // {...register(`OtherSisterConcern.${index}.Mobile`)}
                                                                register={register}
                                                                name={`OtherSisterConcern.${index}.Mobile`}
                                                                label={`Phone No.`}
                                                                Controller={Controller}
                                                                control={control}
                                                                placeholder={"Enter"}
                                                                handleChange={() => { }}
                                                                rules={{
                                                                    required: true,
                                                                    validate: { checkWhiteSpaces, number },
                                                                    maxLength: 15,
                                                                }}
                                                                customClassName={"withBorder w-full"}
                                                                errors={errors?.OtherSisterConcern?.[index]?.Mobile}
                                                                disabled={true}
                                                                mandatory={true}
                                                            />
                                                            {fields?.length > 1 && (
                                                                <button
                                                                    type="button"
                                                                    className={"Delete ms-2 mt-0"}
                                                                    onClick={() => removeOtherSisterConcernItem(index)}
                                                                    title="Remove"
                                                                >
                                                                </button>
                                                            )}

                                                        </Col>
                                                    </Row>
                                                </span>
                                            )
                                        })}
                                        <button
                                            type="button"
                                            className={"user-btn mb-2"}
                                            onClick={() => append(sisterConcernItemInitData)}
                                            title="Add More"
                                        >
                                            <div className={"plus mr-0"}></div>
                                        </button>
                                    </>
                                )
                            }
                        </Col>
                    </Row>

                    <Row className="part-detail-wrapper mb-1">
                        <Col md="12"><hr className="hr-seprator mb-3" /></Col>
                        <Col md="12">
                            <Label>
                                Do you have another Relationship with any Havells Employees?
                                <span className="asterisk-required">*</span>
                            </Label>
                        </Col>
                        <Col md="6">
                            <Label className={"d-inline-block align-middle w-auto pl-1 pr-5 mr-5 mb-1 pt-0 radio-box"}>
                                <input
                                    type="radio"
                                    className="zero-based"
                                    // rules={{ required: true }}
                                    // {...register("IsAnyRelationWithQRG")}
                                    {...register("IsAnyRelationWithQRG", { required: radioValidateMsg })}
                                    value="true"
                                // defaultChecked
                                />
                                <span>Yes</span>
                            </Label>
                            <Label className={"d-inline-block align-middle w-auto pl0 mb-1 pt-0 radio-box"}>
                                <input
                                    type="radio"
                                    // rules={{ required: true }}
                                    // {...register("IsAnyRelationWithQRG")}
                                    {...register("IsAnyRelationWithQRG", { required: radioValidateMsg })}
                                    className="vendor-based2"
                                    value="false"
                                />
                                <span>No</span>
                            </Label>
                            {errors?.IsAnyRelationWithQRG && (
                                <div className="text-help">
                                    {errors?.IsAnyRelationWithQRG?.message}
                                </div>
                            )}
                        </Col>
                        <Col md="12">
                            {
                                IsAnyRelationWithQRG === 'true' && (
                                    <Row>
                                        <Col md="3">
                                            <SearchableSelectHookForm
                                                // {...register("RelationShip")}
                                                register={register}
                                                name="RelationShip"
                                                rules={{ required: true }}
                                                placeholder="Select"
                                                Controller={Controller}
                                                control={control}
                                                label="Relationship"
                                                mandatory={true}
                                                errors={errors?.RelationShip}
                                                disabled={false}
                                                options={relationshipList}
                                                handleChange={() => { }}
                                            />
                                        </Col>
                                        <Col md="3">
                                            <TextFieldHookForm
                                                // {...register("EmployeeCode")}
                                                register={register}
                                                name="EmployeeCode"
                                                label={`Employee Code`}
                                                Controller={Controller}
                                                control={control}
                                                placeholder={"Enter"}
                                                handleChange={(e) => {
                                                    // Convert input value to uppercase
                                                    const uppercaseValue = e.target.value.toUpperCase();
                                                    e.target.value = uppercaseValue;
                                                }}
                                                rules={{
                                                    required: true,
                                                    validate: { checkWhiteSpaces, alphaNumeric },
                                                    maxLength: 20,
                                                }}
                                                customClassName={"withBorder"}
                                                errors={errors.EmployeeCode}
                                                disabled={false}
                                                mandatory={true}
                                            />
                                        </Col>
                                        <Col md="3">
                                            <TextFieldHookForm
                                                // {...register("EmployeeName")}
                                                register={register}
                                                name="EmployeeName"
                                                label={`Employee Name`}
                                                Controller={Controller}
                                                control={control}
                                                placeholder={"Enter"}
                                                handleChange={() => { }}
                                                rules={{
                                                    required: true,
                                                    validate: { checkWhiteSpaces, alphabetsOnly },
                                                    maxLength: 100,
                                                }}
                                                customClassName={"withBorder w-full"}
                                                errors={errors.EmployeeName}
                                                disabled={false}
                                                mandatory={true}
                                            />
                                        </Col>
                                        <Col md="3">
                                            <TextFieldHookForm
                                                // {...register("EmployeeLocation")}
                                                register={register}
                                                name="EmployeeLocation"
                                                label={`Employee Location`}
                                                Controller={Controller}
                                                control={control}
                                                placeholder={"Enter"}
                                                handleChange={() => { }}
                                                rules={{
                                                    required: true,
                                                    validate: { checkWhiteSpaces, alphabetsOnly },
                                                    maxLength: 100,
                                                }}
                                                customClassName={"withBorder w-full"}
                                                errors={errors?.EmployeeLocation}
                                                disabled={false}
                                                mandatory={true}
                                            />
                                        </Col>
                                    </Row>
                                )
                            }
                        </Col>
                    </Row>

                    <Row className="part-detail-wrapper">
                        <Col md="12"><hr className="hr-seprator mb-3" /></Col>
                        <Col md="3">
                            <TextFieldHookForm
                                // {...register("TotalStaff")}
                                register={register}
                                name="TotalStaff"
                                label={`Total Staff`}
                                Controller={Controller}
                                control={control}
                                placeholder={"Enter"}
                                handleChange={() => { }}
                                rules={{
                                    required: true,
                                    validate: { checkWhiteSpaces, number },
                                    maxLength: 10,
                                }}
                                customClassName={"withBorder w-full"}
                                errors={errors.TotalStaff}
                                disabled={false}
                                mandatory={true}
                            />
                        </Col>
                        <Col md="3">
                            <TextFieldHookForm
                                // {...register("TotalWorkers")}
                                register={register}
                                name="TotalWorkers"
                                label={`Total Workers`}
                                Controller={Controller}
                                control={control}
                                placeholder={"Enter"}
                                handleChange={() => { }}
                                rules={{
                                    required: true,
                                    validate: { checkWhiteSpaces, number },
                                    maxLength: 10,
                                }}
                                customClassName={"withBorder w-full"}
                                errors={errors.TotalWorkers}
                                disabled={false}
                                mandatory={true}
                            />
                        </Col>
                        <Col md="12" className='mt-4'>
                            <Row className="part-detail-wrapper mb-1">
                                <Col md='3'>
                                    <SearchableSelectHookForm
                                        // {...register("SupplierSpecialization")}
                                        register={register}
                                        name="SupplierSpecialization"
                                        label="Supplier Specialization"
                                        rules={{ required: props?.viewDataFromSupplier?.IsBlockedVendor ? true:false }}
                                        options={specializationList}
                                        placeholder="Select"
                                        Controller={Controller}
                                        control={control}
                                        mandatory={props?.viewDataFromSupplier?.IsBlockedVendor ? true:false}
                                        handleChange={() => { }}
                                        disabled={!props?.viewDataFromSupplier?.IsBlockedVendor}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="justify-content-between sf-btn-footer no-gutters justify-content-between bottom-footer sticky-btn-footer mt-3">
                        <div className="col-sm-12 text-right bluefooter-butn">
                            <button
                                type={"button"}
                                className="reset mr-2 cancel-btn"
                                onClick={() => props.toggleKys1FormTabs("1")}
                            >
                                <i className="fa fa-long-arrow-left me-2" aria-hidden="true"></i>
                                {"Previous"}
                            </button>
                            <button
                                type="submit"
                                className="submit-button save-btn me-2"
                            >
                                <div className="save-icon mr-1"></div>
                                {"Next"}
                            </button>
                        </div>
                    </Row>
                </form>
            </div>
        </>
    )
}

export default BusinessDetails;
